import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import Fuse from 'fuse.js';
import VT from 'vanilla-toast';
import items from '../../htdocs/items_for_fuse.json';
import sizes from '../../htdocs/sizes.json';
import checkLogin from '../checkLogin.js';

window.checkLogin = checkLogin;

window.Alpine = Alpine;
Alpine.plugin(persist);

let fuse = null;

window.copy = function (data, info) {
    navigator.clipboard.writeText(data);

    VT.success(`Copied '${info}'to clipboard`, {
        duration: 2500,
        immediately: true,
    });
    document.getElementById('q').focus();
};

window.createItemUrl = function (item, rotate, sil, target, prefetch) {
    let url_option_rotate = rotate ? '_rotate' : '';
    let url =
        window.location.origin +
        `/img/sign/${target}/options${url_option_rotate}/${item.short_name}.png`;
    if (prefetch) {
        // trigger browser to prefetch the image
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = url;
        link.as = 'image';
        document.head.appendChild(link);
    }

    if (sil) {
        url = `/sil ${url}`;
    }

    return url;
};

window.clickToCopy = function (item, rotate, sil, target) {
    window.copy(
        window.createItemUrl(item.item, rotate, sil, target, true),
        item.item.display_name
    );
};

const signSelect = document.getElementById('sign');

for (const sizeId in sizes) {
    let size = sizes[sizeId];
    const option = document.createElement('option');
    option.value = sizeId;
    option.textContent = size.name; //+ ' (' + size.size + ')';
    signSelect.appendChild(option);
}
signSelect.removeAttribute('disabled');

fuse = new Fuse(items, {
    keys: ['display_name', 'short_name'],
    threshold: 0.3,
    includeScore: true,
    shouldSort: true,
});
document.getElementById('q').removeAttribute('disabled');

window.search = function (query) {
    if (!fuse) {
        console.error('Items not loaded yet');
        return;
    }
    return fuse.search(query, { limit: 100 });
};

window.uploadImage = async function (
    forUser,
    fromSource,
    shortName,
    description,
    fin
) {
    let body = {
        forUser: forUser,
        fromSource: fromSource,
        shortName: shortName,
        description: description,
    };
    switch (fromSource) {
        case 'file':
            var fileInput = document.getElementById('upload-file');
            if (fileInput.files.length === 0) {
                VT.error('No file selected', { duration: 2500 });
                return;
            }
            const reader = new FileReader();
            reader.addEventListener('load', (event) => {
                body.image = event.target.result;
            });
            await reader.readAsArrayBuffer(fileInput.files[0]);

            break;
        case 'url':
            var urlInput = document.getElementById('upload-url');
            if (!urlInput.value) {
                VT.error('No URL provided', { duration: 2500 });
                return;
            }
            body.imageUrl = urlInput.value;
            break;

        default:
            VT.error('Invalid source', { duration: 2500 });
            return;
    }

    const promiseResult = await fetch('/uploadImage', {
        method: 'POST',
        body: JSON.stringify(body),
    });
    var data;
    try {
        data = await promiseResult.json();
    } catch (e) {
        console.error(e);
    }

    if (data && data.success) {
        VT.success('Image uploaded successfully', { duration: 2500 });
        fin(true);
    } else {
        VT.error(`Error uploading image`, { duration: 2500 });
        fin(true);
    }
};

Alpine.start();

// preload all raw images
for (const item of items) {
    const img = new Image();
    img.src = `/img/preview/${item.short_name}.webp`;
}
